import { render, staticRenderFns } from "./alarmInfo.vue?vue&type=template&id=d71160be&scoped=true"
import script from "./alarmInfo.vue?vue&type=script&lang=js"
export * from "./alarmInfo.vue?vue&type=script&lang=js"
import style0 from "./alarmInfo.vue?vue&type=style&index=0&id=d71160be&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d71160be",
  null
  
)

export default component.exports